// src/api/blogApi.js
import http from './http';

const API_URL = '/api/blog';

export const getAllBlogs = () => http.get(API_URL);
export const getBlogBySlug = (slug) => http.get(`${API_URL}/${slug}`);
export const createBlog = (data) => http.post(API_URL, data);
export const updateBlog = (id, data) => http.put(`${API_URL}/${id}`, data);
export const deleteBlog = (id) => http.delete(`${API_URL}/${id}`);
